import React from 'react';
import { useAuth } from '../../providers/auth-provider';

function ClientDashboardHeader() {
  const { isDevelop } = useAuth();

  return (
    <div className="d-flex pt-4 pb-2 w-100 justify-content-center sticky-top bg-light">
      <h1 className="display-4">{`${isDevelop() ? 'Leadership ' : 'Candidate '}Dashboard`}</h1>
    </div>
  );
}

export default ClientDashboardHeader;
